import { ChangeDetectorRef, inject, Pipe, PipeTransform } from '@angular/core';
import { RegionStore } from '../store/region.store';
import { AsyncPipe } from '@angular/common';
import { RegionId } from '../model/region-id.enum';
import { map } from 'rxjs';

@Pipe({
    name: 'regionImage',
    standalone: true,
})
export class RegionImagePipe implements PipeTransform {
    private readonly _regionStore = inject(RegionStore);
    private readonly _regions$ = this._regionStore.regions$;
    private readonly _cdr = inject(ChangeDetectorRef);
    private readonly asyncPipe = new AsyncPipe(this._cdr);

    transform(value: RegionId) {
        return this._regions$.pipe(map(regions => regions.find(r => r.id === value)?.image));
    }

    ngOnDestroy(): void {
        this.asyncPipe.ngOnDestroy();
    }
}
